import Stack from "@mui/material/Stack";
import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";
import { ElementSelector } from "@src/features/experienceBuilder/modifications/basicMods/ElementSelector";
import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import React from "react";

interface ElementSelectionProps {
  mod: Extract<EmbeddedMod, { selector: string }>;
  errors?: Record<string, string>;
  onChange?: (selector: { selector: string } | { description: string }) => void;
}

export const ElementMeta = ({
  mod,
  errors,
  onChange,
}: ElementSelectionProps) => {
  return (
    <>
      <Stack spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Panel.Label>Element selection</Panel.Label>
          <ElementSelector mod={mod} />
        </Stack>
        <Panel.TextField
          value={mod.selector}
          onChange={(e) => onChange?.({ selector: e.target.value })}
          placeholder="#shopify-section-template--1838384..."
          error={Boolean(errors?.selector)}
        />
      </Stack>
      <Panel.TextField
        label={
          <>
            Element description
            <Panel.Optional />
          </>
        }
        value={mod.description}
        onChange={(e) => onChange?.({ description: e.target.value })}
        placeholder="Optional label for your reference"
      />
    </>
  );
};
